import Api from "./ApiNode";

export default {
 
    getAllShippingBillServiceList(payload, config) {
         let AllCommonJobList = Api().post("shipping-bill/get", payload, config);
        return AllCommonJobList;
    },
    getAllShippingBillList(payload, config) {
        return this.getAllShippingBillServiceList(payload, config);
    },
    upsertExcelBulkShippingBill(payload, config) {
        let AllCommonJobList = Api().post("shipping-bill/excel-bulk-shipping-bill", payload, config);
        return AllCommonJobList;
    },
    getBulkShippingBillProgress(payload, config) {
        let AllCommonJobList = Api().post("shipping-bill/excel-bulk-shipping-bill/progress", payload, config);
        return AllCommonJobList;
    },

    clearShippingBillService(payload, config) {
        let AllCommonJobList = Api().post("shipping-bill/clear-shipping-bill", payload, config);
        return AllCommonJobList;
    },
    clearShippingBill(payload, config) {
        return this.clearShippingBillService(payload, config);
    },
   
};



// WEBPACK FOOTER //
// ./src/services/ShippingBillService.js